import { isServer, mixins, Spinner, styled } from '@bob/library'
import React, { PropsWithChildren, Suspense, useMemo } from 'react'

const MainWrapper = styled.div`
  min-height: 600px;
`

const LoadingWrapper = styled(MainWrapper)`
  margin: 0 auto;
  text-align: center;
`

export const WithSuspense: React.FC<PropsWithChildren> = ({ children }) => {
  const Loading = () =>
    useMemo(
      () => (
        <LoadingWrapper>
          <Spinner color={mixins.colors.grayDark} size={60} />
        </LoadingWrapper>
      ),
      []
    )

  return (
    <MainWrapper>{!isServer && <Suspense fallback={<Loading />}>{children}</Suspense>}</MainWrapper>
  )
}
